import styled from "styled-components";

export const Card = styled.div`
  border: ${(p) => p.border && p.border};
  background: ${(p) => p.background && p.background};
  border-radius: ${(p) => p.borderradius && p.borderradius};
  padding: ${(p) => p.padding && p.padding};
  margin-top: ${(p) => p.margintop && p.margintop};
  width: ${(p) => p.width && p.width};
  height: ${(p) => p.height && p.height};
  min-height: 260px;
  height: auto;
  grid-area: Appointment;
`;

export const Comdisp = styled.div`
  display: ${(p) => p.disp && p.disp};
  margin-top: ${(p) => p.marginTop && p.marginTop};
  margin-bottom: ${(p) => p.marginBottom && p.marginBottom};
  margin-left: ${(p) => p.marginLeft && p.marginLeft};
  align-items: ${(p) => p.alignItem && p.alignItem};
  justify-content: ${(p) => p.JustifyContent && p.JustifyContent};

  & .clock {
    color: #7d8592;
    margin-right: 15px;
  }
  & .locate {
    height: 20px;
    width: 20px;
    color: #7d8592;
    margin-right: 12px;
  }
`;

export const Hrline = styled.hr`
  border: 1px solid #d8e0f0;
  margin-top: ${(props) => (props.mt ? props.mt : "20px")};
  margin-bottom: ${(p) => (p.mb ? p.mb : "20px")};
  border-bottom: none;
  margin: ${(props) => props.margin && props.margin};
`;

export const AppointmentWrapper = styled.div`
  padding: 4px 0;
`;

export const AppointmentTitle = styled.div`
  font-weight: 600;
  color: #1a1a1a;
  font-size: 13px;
  line-height: 22px;
`;

export const AppointmentSubText = styled.div`
  color: #000;
  font-size: 12px;
  margin-top: 2px;
  line-height: 16px;
`;

export const AppointmentActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;
export const AppointmentAddressRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 6px;
`;
